import type { SnorfLayout } from '@snorf';
import { immerable } from '@utils';
import { NodeLayout } from './NodeLayout';

/* ------------------------------------------------------------------ */
/*  Unit-specific layout (identical to NodeLayout but nominal type)   */
/* ------------------------------------------------------------------ */
export class UnitLayout extends NodeLayout {
  [immerable] = true;

  constructor(snorfLayout: SnorfLayout, opacity = 1) {
    super(snorfLayout.center, snorfLayout.size, undefined, opacity);
    this.snorfLayout = snorfLayout;
  }
}
